/* eslint-disable max-len */
import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
// import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
import { useSelector } from 'react-redux';
import warningLogo from '../../../../../../assets/warning.svg';
import styles from './AddScheduleConfirmationModalStyle.module.scss';
import { RootState } from '../../../../../../redux/rootState';
import { convertDateFormat } from '../../../../../../utils/CommonFunctions';
import { EventDetails } from '../../../../../calender/utils/types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  height: 'auto',
  overflowY: 'auto',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
type TypesConfirmModal = {
  show: boolean;
  setOpenFrom: () => void;
  callback: () => void;
  analystName: string;
};

export default function AddScheduleConfirmationModal({
  show, setOpenFrom, callback, analystName,
}: TypesConfirmModal): JSX.Element {
  const { eventListWithinDate } = useSelector((state: RootState) => state.CalenderReducer);

  // const [vacations, sickLeaves, appointments, jobs] = useMemo(() => {
  //   if (eventListWithinDate) {
  //     const vac = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 1);
  //     const vacStr = vac?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
  //     const sic = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 2);
  //     const sickSt = sic?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
  //     const app = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 3);
  //     const appStr = app?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
  //     const job = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 4);
  //     const jobStr = job?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
  //     return [vacStr, sickSt, appStr, jobStr];
  //   } return [[], [], [], []];
  // }, [eventListWithinDate]);
  const leaveEvents = useMemo(() => {
    const e: EventDetails[] = [];
    // eslint-disable-next-line array-callback-return
    eventListWithinDate?.map((item) => {
      e.push(...item.Events);
    });
    return e?.filter((item) => [1, 2].includes(item?.EventId));
  }, [eventListWithinDate]);

  const getEvents = (events: EventDetails[]) => {
    const vac = events?.filter((item) => item?.EventId === 1);
    const vacStr = vac?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
    const sic = events?.filter((item) => item?.EventId === 2);
    const sickSt = sic?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
    const app = events?.filter((item) => item?.EventId === 3);
    const appStr = app?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
    const job = events?.filter((item) => item?.EventId === 4);
    const jobStr = job?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
    return {
      vacStr, sickSt, appStr, jobStr,
    };
  };

  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          {/* <DeleteModalIcon /> */}
          <img src={warningLogo} alt="Warning" height={100} width={100} />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          {analystName?.length > 0 ? analystName : 'The below analysts'}
          &nbsp;
          have events already scheduled within the selected date range:
        </div>
        {(eventListWithinDate?.filter((item) => item?.Events?.length > 0))?.map((item) => {
          const eve = getEvents(item?.Events);
          return (
            <div className={styles.modalDescriptionContainer}>
              <div className={styles.modalModalDescriptionBlue}>
                <p>Analyst</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                <p>{item?.AnalystName}</p>
              </div>
              {eve?.vacStr?.length > 0 && (
              <div className={styles.modalModalDescriptionRed}>
                <p>Vacations</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;:&nbsp;
                <p>{eve.vacStr}</p>
              </div>
              )}
              {eve?.sickSt?.length > 0 && (
              <div className={styles.modalModalDescriptionRed}>
                <p>Sick Leaves</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                <p>{eve.sickSt}</p>
              </div>
              )}
              {eve?.appStr?.length > 0 && (
              <div className={styles.modalModalDescriptionGreen}>
                <p>Appointments</p>
          &nbsp;&nbsp;:&nbsp;
                <p>{eve.appStr}</p>
              </div>
              )}
              {eve?.jobStr?.length > 0 && (
              <div className={styles.modalModalDescriptionGreen}>
                <p>Jobs Sch.</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;:&nbsp;
                <p>{eve.jobStr}</p>
              </div>
              )}
              <br />
            </div>
          );
        })}
        {/* <div className={styles.modalDescriptionContainer}>
          {vacations?.length > 0 && (
          <div className={styles.modalModalDescriptionRed}>
            <p>Vacations</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;:&nbsp;
            <p>{vacations}</p>
          </div>
          )}
          {sickLeaves?.length > 0 && (
          <div className={styles.modalModalDescriptionRed}>
            <p>Sick Leaves</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
            <p>{sickLeaves}</p>
          </div>
          )}
          {appointments?.length > 0 && (
          <div className={styles.modalModalDescriptionGreen}>
            <p>Appointments</p>
          &nbsp;&nbsp;:&nbsp;
            <p>{appointments}</p>
          </div>
          )}
          {jobs?.length > 0 && (
          <div className={styles.modalModalDescriptionGreen}>
            <p>Jobs Sch.</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;:&nbsp;
            <p>{jobs}</p>
          </div>
          )}
        </div> */}
        <div className={leaveEvents?.length > 0 ? styles.modalModalDescriptionWithMarginRed : styles.modalModalDescriptionWithMargin}>
          {leaveEvents?.length > 0 ? 'This job cannot be scheduled because some of the selected analysts are on vacation or sick leave during the specified date range.' : 'Do you still want to proceed?'}
        </div>

        {leaveEvents?.length > 0 ? (
          <div className={styles.divButtons}>
            <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Close</button>
          </div>
        ) : (
          <div className={styles.divButtons}>
            <button
              type="button"
              className={`btn ${styles.deleteBtn}`}
              onClick={callback}
            >
              YES
            </button>
            <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>NO</button>
          </div>
        )}
      </Box>
    </Modal>
  );
}
